const menuItems = [
  {
    title: 'Home',
    path: '/',
  },
  {
    title: "Mr Solutions",
    path: "/MrSpecialist"
  },
  {
    title:"Blogs",
    path:"/blogs"
  },
  {
    title: 'About Us',
    subMenu: [
      { title: 'Nycs Profile', path: '/about/story' },
      { title: 'Board', path: '/about/vision' },
      { title: 'Major Activities', path: '/about/activities' },  // 👈 new item here
      {title:'Events',path:"/about/events"}
    ],
  },
  {
    title: 'Our Dimensions',

    subMenu: [
      { title: 'Kovida', path: '/dimensions/Kovida' },
      { title: 'Sports', path: '/dimensions/Sports' },
      { title: 'Jana Nidhi', path: '/dimensions/JanaNidhi' },
      // { title: 'Bio Energy', p ath: '/dimensions/Bioenergy' },
      { title: 'Yuva Expo', path: '/dimensions/YuvaExpo' },
      { title: 'Yuva Sahkar', path: '/dimensions/YuvaSahkar' },


    ],
  },
  // {
  //   title: 'Events',
  //   path: '/Events'
  // },
  // {
  //   title: 'Our Network',

  //   subMenu: [
  //     { title: 'Kaushalya Setu Abhiyan Map', path: '/network/KaushalyaMap' },
  //     { title: 'PMKVY Centers', path: '/network/PMKVY' },
  //     { title: 'GAIL-Raftaar-Map', path: '/network/GAILS' },
  //     { title: 'SR Contact List', path: '/network/SRContact' },

  //   ],
  // },
  {
    title: 'Become a Member',
    path: "/FormApplication"
    // subMenu: [
    //   { title: "Kaushalya Sethu Abhiyan", path: "/KaushalyaSethuAbhiyanForm" },
    //   // { title: "JanaNidhi", path: "/JanaNidhiForm" },
    //   { title: "Become a member",  }
    //   // { title: "Jan Aushashi", path: "/JanAushadhi" }
    // ]
  },
  {
    title: 'Gallery',

    subMenu: [
      { title: "Photos", path: "/photos" },
      { title: "Videos", path: "/videos" }
    ]
  },
  {
    title: 'Contact',
    path: '/Contact',
  },
  {
    title: 'Student Chapter',
    path: '/StudentChapter'
  },

];

export default menuItems;   
